import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../common/GridLayout";
import { LoadPanel } from 'devextreme-react/load-panel';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Editing,
    RequiredRule,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Toolbar,
    Item
} from "devextreme-react/data-grid";
import "jspdf-autotable";
import "../css/omstyle.css";
import data from "../../assets/apiRoutes.json";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import notify from 'devextreme/ui/notify';
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
const OMDetailItems = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const Ompricelevel = props.oidc.user.profile.OMDEFAULTPRICELEVEL;
    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);

    }, [setLoadPanelVisible]);
    const [showIndicator, setShowIndicator] = useState(true);
    const [shading, setShading] = useState(true);
    const [showPane, setShowPane] = useState(true);
    const [hideOnOutsideClick, setHideOnOutsideClick] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    const detailDataGrid = useRef(null);
    const getSelectedRows = () => {
        if (detailDataGrid && detailDataGrid.current) {
            const instance = detailDataGrid.current.instance();
            if (instance && typeof instance.getSelectedRowKeys === 'function') {
                return instance.getSelectedRowKeys();
            }
        }
        return [];
    };
    const position = { of: '#accordion-containe2' };
    var permissions = props.ReceiptReducer.rolePermissions;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "3115cc3c-3d8e-403b-ad97-cadd5ee968f9";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    /* const fetchTransactioDetail = (accessToken, selectedTab, headerRowId) => {
        const resultData = createStore({
            key: 'key',
            loadParams:
            {
                headerRowId: function () {
                    return headerRowId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetDetailItems}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.AddSelectedItems}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                    headerId: headerRowId,
                };
            },
            onModified: (method, ajaxOptions) => {
                // const dataGridInstance = detailDataGrid.current.instance();
                // const dataSource = dataGridInstance.getDataSource();
                // dataGridInstance.option("disabled", true);
                // dataSource.reload().done(() => {
                //     dataGridInstance.option("disabled", false);
                // });
               
                notify(
                    {
                        message: 'Record has been updated successfully.',
                        width: 100,
                    },
                    'success',
                    3000,
                );
            }
        });
        return resultData;
    } */
    const fetchTransactioDetail = (accessToken, selectedTab, headerRowId) => {
        const resultData = createStore({
            key: 'key',
            loadParams: {
                headerRowId: function () {
                    return headerRowId;
                }
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.OM.GetDetailItems}`,
            updateUrl: `${window._env_.REACT_APP_APIS}/${data.OM.AddSelectedItems}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                    headerId: headerRowId,
                };
            },
            onModified: (method, ajaxOptions) => {
                if (detailDataGrid && detailDataGrid.current) {
                    const instance = detailDataGrid.current.instance();
                    if (instance && typeof instance.getDataSource === 'function') {
                        const dataSource = instance.getDataSource();
                        if (dataSource && typeof dataSource.reload === 'function') {
                            dataSource.reload();
                        }
                    }
                }
                notify(
                    {
                        message: 'Record has been updated successfully.',
                        width: 100,
                    },
                    'success',
                    3000,
                );
            }
        });
        return resultData;
    }
    const resultData =  fetchTransactioDetail(accessToken, props.selectedTab, props.headerRowId);
    const onContentReady = (e) => {
        if (!e.component._hasLoaded) {
          e.component._hasLoaded = true;
          e.component.option("dataSource",resultData)
        }
      }

    const cellPrepared = (e) => {
        if (e.rowType === "data") {
            if (e.column.dataField === "quantityorder") {
                e.cellElement.style.borderBottom = "1px solid red";
            }
        }
    }
    return (
        <div >
            <LoadPanel
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={showIndicator}
                shading={shading}
                showPane={showPane}
                hideOnOutsideClick={hideOnOutsideClick}
            />
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={detailDataGrid}
                allowColumnReordering={true}
                allowColumnResizing={true}
                dataSource={resultData}
                showBorders={true}
                hoverStateEnabled={true}
                className={props.searchPanelStatus ? "GridHeightAccordianOpen-tabs" : "GridHeightAccordianClose-tabs"}
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                onCellPrepared={cellPrepared}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <HeaderFilter enabled={false} visible={false} />
                <GroupPanel visible={false} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
                <FilterRow visible={true} />
                <Scrolling mode="virtual" />
                <Column dataField="selected" fixed={true} fixedPosition="left" allowReordering={false} allowResizing={false} dataType="boolean" caption="#" >
                </Column>
                <Column
                    dataField="quantityorder"
                    dataType="number"
                    caption="Ordered"
                    allowReordering={false} allowResizing={false}
                    defaultSortOrder="desc"
                ></Column>
                <Column dataField="warehouse" caption='Warehouse' allowEditing={false} ></Column>
                <Column dataField="itemCode" caption='Item' allowEditing={false} ></Column>
                <Column dataField="description_1" caption='Description' allowEditing={false} ></Column>
                <Column dataField="lotcode" caption='Lot' allowEditing={false} ></Column>
                <Column dataField="lotDescription1" caption='Lot Description' allowEditing={false} ></Column>
                <Column dataField="classCode" caption='Item Class Code' allowEditing={false} ></Column>
                <Column dataField="subClassCode" caption='Item SubClass Code' allowEditing={false} ></Column>
                <Column dataField="status" caption='Item Status' allowEditing={false} ></Column>
                <Column dataField="lotstatus" caption='Lot Status' allowEditing={false} ></Column>
                <Column dataField="available" caption='Available Qty' allowEditing={false} ></Column>
                <Column dataField="netavailable" caption='Net Available Qty' allowEditing={false} ></Column>
                <Column dataField="unitPrice" caption='Unit Price' allowEditing={false} ></Column>
           <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item>
                    </Item>
                 <Item name="exportButton"  />
                 <Item name="columnChooserButton"/>
           </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(OMDetailItems);